/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    notes: [],
};

const leadsSlice = createSlice({
    name: 'leads',
    initialState,
    reducers: {
        setNotes: (state, action) => {
            state.notes = action.payload;
        },
    },
});

export const { setNotes } = leadsSlice.actions;

export default leadsSlice.reducer;
